import type { IncomingMessage } from 'http'


export default function getSubtenantFromQueryParams(req: IncomingMessage): string | undefined {
  const urlParams = new URLSearchParams((req?.url || '').split('?')[1])
  const subtenant = urlParams.get('subtenant') || ''
  return subtenant
}
